import React from "react";
import { FieldAttributes, useField, useFormikContext } from "formik";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "moment/locale/de";
import "moment/locale/es";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

type UploadDatePickerProps = {
  label: string;
} & FieldAttributes<{}>;

export const UploadDatePicker: React.FC<UploadDatePickerProps> = (props) => {
  const [field, meta] = useField<{}>(props);
  const { setFieldValue } = useFormikContext();
  const { i18n } = useTranslation();
  moment.locale(i18n.language);
  const errorText = meta.error && meta.touched ? meta.error : "";

  const handleChange = (date: MaterialUiPickersDate) => {
    setFieldValue(field.name, date!.format('YYYYMMDD'));
  }

  return (
    <MuiPickersUtilsProvider utils={MomentUtils} locale={i18n.language}>
      <DatePicker
        label={props.label}
        format="L"
        margin="normal"
        fullWidth
        autoOk
        disableFuture
        openTo="year"
        views={["year", "month", "date"]}
        helperText={errorText}
        error={!!errorText}
        {...field}
        onChange={handleChange}
      />
    </MuiPickersUtilsProvider>
  );
};
